import _ from "lodash";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  verifyCode,
  resendOtp,
  changeEmail,
  resetVerifyCode,
  toChangeEmail,
} from "SignupActions";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import LoginErrorBar from "./../errorbar";
// need to implement the resend code and change email functionality

class SignupVerify extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);

    this.onClickChangeEmail = this.onClickChangeEmail.bind(this);
    this.onClickResendCode = this.onClickResendCode.bind(this);
    this.hideAlert = this.hideAlert.bind(this);

    this.state = {
      code: ["", "", "", ""],
      showAlert: false,
      alertMessage: "",
      alertTitle: "Error",
    };
  }

  hideAlert() {
    this.setState({ ...this.state, showAlert: false });
  }

  onInputChange(event) {
    //debugger;
    var codeID = _.replace(event.target.id, "code", "");

    var codeType = _.parseInt(codeID);
    var codes = this.state.code;
    codes[codeType - 1] = event.target.value;

    this.setState({ code: codes });

    if (codeType === 4) {
      //Check and verify the code entered
      //this.props.showLoading();
      var code = codes[0] + codes[1] + codes[2] + codes[3];
      var values = {
        otp: code,
      };
      this.props.verifyCode(
        values,
        this.props.otp,
        this.props.user,
        this.props.session,
        (response) => {
          //this.props.hideLoading();
          if (response.success === 1) {
            // nothing to do. otp is verified
          } else {
            this.setState({
              ...this.state,
              showAlert: true,
              alertMessage: response.message,
              code: ["", "", "", ""],
            });
            codeType = 0;
            var inputID = `code${codeType + 1}`;
            document.getElementById(inputID).focus();
            setTimeout(() => {
              this.setState({ ...this.state, showAlert: false });
            }, 3000);
          }
        }
      );
    } else {
      var inputID = `code${codeType + 1}`;
      document.getElementById(inputID).focus();
    }
  }

  onFormSubmit(event) {
    this.props.callback();
  }

  onClickResendCode() {
    this.props.resendOtp(this.props.session, (response) => {
      if (response.success === 0) {
      } else {
        this.setState({
          ...this.state,
          showAlert: true,
          alertMessage: "Unable to resend OTP",
        });
        setTimeout(() => {
          this.setState({ ...this.state, showAlert: false });
        }, 3000);
      }
    });
  }

  onClickChangeEmail() {
    this.props.changeEmail();
  }

  componentDidMount() {
    this.props.toChangeEmail(false);
  }

  render() {
    return (
      <div>
        {/* {this.state.showAlert?<LoginErrorBar style={{top:'-10px'}} alertMessage={this.state.alertMessage} />:''} */}
        <form onSubmit={this.onFormSubmit} className="steps-animation">
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="verify-title">Verify Your Account</div>
              <div className="verify-desc">
                {"We've sent a four digit confirmation code to"}{" "}
                <strong>{this.props.user.email}</strong>. It will expire
                shortly, so enter your code soon.
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-2">&nbsp;</div>
            <div className="col-md-8">
              <div className="text-center form-group verify-element">
                <input
                  type="text"
                  className="form-control no-spin"
                  maxLength="1"
                  id="code1"
                  value={this.state.code[0]}
                  onChange={this.onInputChange}
                />
                <input
                  type="text"
                  className="form-control no-spin"
                  maxLength="1"
                  id="code2"
                  value={this.state.code[1]}
                  onChange={this.onInputChange}
                />
                <input
                  type="text"
                  className="form-control no-spin"
                  maxLength="1"
                  id="code3"
                  value={this.state.code[2]}
                  onChange={this.onInputChange}
                />
                <input
                  type="text"
                  className="form-control no-spin"
                  maxLength="1"
                  id="code4"
                  value={this.state.code[3]}
                  onChange={this.onInputChange}
                />
              </div>
            </div>
            <div className="col-md-2">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
          <div className="row verify-actions">
            <div className="col-md-12">
              <div className="horizontal-align-center">
                Haven&#39;t received the code yet?
              </div>
              <div className="horizontal-align-center">
                <div onClick={this.onClickResendCode} className="dummy-link">
                  Resend Code
                </div>
              </div>
              <div className="horizontal-align-center">
                <div onClick={this.onClickChangeEmail} className="dummy-link">
                  Change Email Address
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">&nbsp;</div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps({ otp, user, session }) {
  return { otp, user, session };
}

export default connect(mapStateToProps, {
  verifyCode,
  toChangeEmail,
  showLoading,
  hideLoading,
  resendOtp,
  changeEmail,
})(SignupVerify);
